export const SUBJECT_LIST_ERROR = "SUBJECT_LIST_ERROR";
export const SUBJECT_LIST_SUCCESS = "SUBJECT_LIST_SUCCESS";
export const SUBJECT_LIST_LOADING = "SUBJECT_LIST_LOADING";
export const SYLLABUS_DETAILS_ERROR = "SYLLABUS_DETAILS_ERROR";
export const SYLLABUS_DETAILS_SUCCESS = "SYLLABUS_DETAILS_SUCCESS";
export const SYLLABUS_DETAILS_LOADING = "SYLLABUS_DETAILS_LOADING";
